import { rankingData } from '@/mocks/homeData';

export default function SectionRanking() {
  const getRankStyle = (rank: number) => {
    if (rank === 1) return 'bg-accent-500 text-background-50';
    if (rank === 2) return 'bg-primary-400 text-background-50';
    if (rank === 3) return 'bg-secondary-400 text-background-50';
    return 'bg-background-200 text-foreground-600';
  };

  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
            热度榜单
          </h2>
          <p className="text-foreground-500 text-sm">实时热搜，看看今天大家都在吃哪些瓜</p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden">
          {rankingData.map((item, i) => (
            <div
              key={item.id}
              className={`flex items-center gap-3 p-4 md:p-5 cursor-pointer hover:bg-primary-50/30 transition-colors duration-150 ${
                i < rankingData.length - 1 ? 'border-b border-background-200/40' : ''
              }`}
            >
              <div
                className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${getRankStyle(
                  item.rank
                )}`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-foreground-800 font-bold text-sm truncate">{item.title}</h3>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-foreground-400 text-xs whitespace-nowrap">{item.heat}</span>
                <i
                  className={`text-sm ${
                    item.trend === 'up'
                      ? 'ri-arrow-up-line text-primary-500'
                      : 'ri-arrow-down-line text-foreground-400'
                  }`}
                ></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}